<h2 class="headline mb-4 flex items-center flex-none">
  <mat-icon
    class="mr-3 slc-color-brand"
    svgIcon="mat:vertical_split"
  ></mat-icon>
  <span>Selecionar Card</span>
</h2>

<div class="flex-1 overflow-hidden flex flex-col">
  <div class="flex justify-between vex-mat-dense-xs mb-2 flex-none">
    <div
      class="relative h-10 min-w-14"
      [class.search-form]="!searchControl.value"
    >
      <div
        [matBadge]="searchControl.value ? filteredCards().length : ''"
        matBadgeSize="small"
        class="absolute left-3 top-3 slc-badge-accent"
      >
        <mat-icon svgIcon="mat:search"></mat-icon>
      </div>

      <mat-form-field subscriptSizing="dynamic" tabindex="0">
        <input
          matInput
          [formControl]="searchControl"
          type="text"
          placeholder="Pesquisar&hellip;"
          class="pl-8"
        />
      </mat-form-field>
    </div>
    <button
      mat-mini-fab
      matTooltip="Criar Novo Card"
      class="slc-btn-mini-fab-brand"
      (click)="criarCardSidebar.open()"
      [class.invisible]="!can('criar', 'dashboards-cards')"
    >
      <mat-icon svgIcon="mat:add"></mat-icon>
    </button>
  </div>

  <div class="overflow-auto flex-1 mb-4 mt-2">
    <div
      class="flex flex-col"
      cdkDropList
      [cdkDropListData]="filteredCards()"
      [cdkDropListSortPredicate]="onSortPredicate"
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (card of filteredCards(); track card.id) {
      <div
        class="p-2 inline-flex hover:bg-primary-200 justify-between items-center"
        cdkDrag
        [cdkDragDisabled]="!card.sel.value"
        [cdkDragData]="card"
      >
        <div
          class="rounded-full w-8 h-8 flex-none flex items-center justify-center bg-primary-100"
          [class.cursor-move]="card.sel.value"
          cdkDragHandle
          [matMenuTriggerFor]="
            can('excluir', 'dashboards-cards') ? cardAcoes : null
          "
          [matMenuTriggerData]="{ card }"
        >
          <mat-icon
            [svgIcon]="getIconTipoCard(card.tipo)"
            class="slc-color-brand"
          ></mat-icon>
        </div>
        <div class="flex-auto mx-4 body-1">{{ card.titulo }}</div>
        <div class="flex-none">
          <mat-checkbox
            class="slc-checkbox-brand"
            [formControl]="card.sel"
            (change)="onChangeSel(card)"
          ></mat-checkbox>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div class="flex-none flex justify-end items-end gap-2">
  <button mat-button type="button" (click)="sidebarComponent()?.close()">
    Cancelar
  </button>
  <button
    class="slc-btn-filled-brand"
    mat-flat-button
    type="button"
    (click)="onSelecionar()"
  >
    Selecionar
  </button>
</div>

<!-- Criar Card -->
<vex-sidebar #criarCardSidebar position="right" [invisibleBackdrop]="false">
  @if (criarCardSidebar.opened) {
  <app-dashboard-criar-card
    [sidebarComponent]="criarCardSidebar"
  ></app-dashboard-criar-card
  >}
</vex-sidebar>

<!-- Menu -->
<mat-menu #cardAcoes="matMenu">
  <ng-template matMenuContent let-card="card">
    <button mat-menu-item (click)="onExcluirCard(card)">
      <mat-icon svgIcon="mat:delete"></mat-icon>
      <span>Excluir Card</span>
    </button>
  </ng-template>
</mat-menu>
